<div class="step-content">
    <div class="step-header page-header">
        <h2 class="step-title">Locations</h2>
    </div>
    <div class="step-header section-header">
        <div class="section-heading">
            <h2>Practice locations</h2>
            <span class="section-count" *ngIf="!showInitialEmptyState">{{ totalRecords }} total</span>
        </div>
        <p class="description-note" *ngIf="!showInitialEmptyState">Review the practice locations linked to your credentialing application.
            Select <strong>Add location</strong> to enter a new office by its TIN — we'll help you look up the address and payee details, then it appears in the grid below for review before you submit.</p>
    </div>
        <div class="location-mainouter">
        <div class="location-controls" [ngClass]="{ 'location-controls-empty': showInitialEmptyState }">
            <div class="search-box" *ngIf="!showInitialEmptyState">
                <label class="control-label">Location filter</label>
                <div class="input-wrapper">
                    <app-text-input [for] = "'search-Input'" [placeholder]="'Search'"
                    (keyup)="filterTable($event)"></app-text-input>
                    <img alt="search" src="../../../../../assets/images/unsubmit-search.svg"  class="search-icon">
                </div>
            </div>
            <div class="add-location-cta">
                <button type="button" class="btn btn-primary add-location-btn" (click)="onAddLocation()" [disabled]="impersonatedUser">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    Add a location
                </button>
                <div class="start-here-prompt" *ngIf="showInitialEmptyState">
                    <span class="start-here-arrow">&#8599;</span>
                    <span>Start here</span>
                </div>
            </div>
        </div>

        <div class="empty-state" *ngIf="showInitialEmptyState">
            <h3>No locations added yet</h3>
            <p>Your application needs at least one practice location. Use <strong>Add a location</strong> at the top right to begin.</p>
        </div>
 
        <div *ngIf="!showInitialEmptyState">
        <div class="pagination-example table-container desktop-only locations-table-wrapper" #tableWrapper>
            <app-table class="list-table location-table" [data]="pagedLocationData"
            [columns]="tableColumns" id="tblAdmin" (clickEvent)="onTableClick($event)">
          </app-table>
          @if(!dataSource.data.length){
            <div class="text-center no-data-msg">
                No records found
            </div>
            }
        </div>
        <div *ngIf="dataSource && dataSource.data.length">
            <mat-paginator #locationPaginator
            [length]="totalRecords"
            [pageSize]="currentPageSize"
            [pageIndex]="currentPageIndex"
            [pageSizeOptions]="[5, 10, 20]"
            aria-label="Select page"
            (page)="onPageChange($event)">
          </mat-paginator>
          </div>

        <!-- Mobile Card View -->
        <div class="mobile-cards mobile-only" *ngIf="dataSource.data.length > 0">
            <div class="location-card" *ngFor="let item of dataSource.data">
                <div class="card-row" *ngIf="!item.esLocationId&&!this.impersonatedUser">
                    <span class="card-label"></span>
                    <span class="card-value name-value" (click)="onTableClick({data:item.locationId,otherParams:'delete'})">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="delete-icon" data-action="DELETE">
                            <polyline points="3 6 5 6 21 6"></polyline>
                            <path d="M19 6l-1 14H6L5 6"></path>
                            <path d="M10 11v6"></path>
                            <path d="M14 11v6"></path>
                            <path d="M9 6V4h6v2"></path>
                        </svg>
                    </span>
                </div>
                <div class="card-row">
                    <span class="card-label">Location name</span>
                    <span class="card-value">{{ item.name }}</span>
                </div>
                <div class="card-row">
                    <span class="card-label">TIN</span>
                    <span class="card-value">{{ item.tin }}</span>
                </div>
                <div class="card-row">
                  <span class="card-label">Effective date</span>
                  <span class="card-value">{{ item.effectiveDate }}</span>
              </div>
                <div class="card-row">
                    <span class="card-label">Address</span>
                    <span class="card-value">{{ item.address1 }}</span>
                </div>
                <div class="card-row">
                    <span class="card-label">City</span>
                    <span class="card-value">{{ item.city }}</span>
                </div>
                <div class="card-row">
                    <span class="card-label">State</span>
                    <span class="card-value">{{ item.state }}</span>
                </div>
                <div class="card-row">
                    <span class="card-label">Participating</span>
                    <span class="card-value">{{ item.participating }}</span>
                </div>
                <div class="card-row">
                    <span class="card-label">Primary</span>
                    <span class="card-value">{{ item.Primary }}</span>
                </div>
                <div class="card-row">
                    <span class="card-label">Action</span>
                    <button class="btn-action" [ngClass]="getLocationActionStatusClass(item)"
                        (click)="onTableClick({data: (item.locationId !== null && item.locationId !== undefined ? item.locationId : item.esLocationId), row: item, otherParams:'edit'})">Edit</button>
                </div>
            </div>
        </div>
        </div>
    </div>

<div *ngIf="!showInitialEmptyState">
<div class="section-divider"></div>
<div class="step-header section-header tin-section-header">
    <div class="section-heading">
        <h2>TIN management</h2>
        <span class="section-count">{{ tinTotalRecords }} total</span>
    </div>
    <p class="description-note">Tax IDs associated with your participating locations above. Upload a current W-9 for each TIN.</p>
</div>

<div class="location-mainouter tin-management-content">

   
    <div class="location-controls">
  
          <div class="search-box">
            <label class="control-label">TIN filter</label>
            <div class="input-wrapper">
                <app-text-input [for] = "'search-Input'" [placeholder]="'Search'"
                (keyup)="filterTinTable($event)"></app-text-input>
                <img alt="search" src="../../../../../assets/images/unsubmit-search.svg"  class="search-icon">
            </div>
        </div>

      
      <!-- <button class="btn add-location-btn" (click)="onAddTin()">
        Add tax payee
      </button> -->
  
    </div>
  
    
  <div class="table-container">
  <app-upload-trigger #w9Uploader [accept]="accept" (fileSelected)="onW9FileSelected($event)"></app-upload-trigger>
  <div class="pagination-example table-container desktop-only tin-table-wrapper" #tinTableWrapper>
    <app-table 
      class="list-table location-table"
      [data]="tinDataSource.data"
      [columns]="tinColumns"
      (clickEvent)="onTinTableClick($event)">
    </app-table>
  
    <div *ngIf="!tinDataSource.data.length" class="text-center no-data-msg">
      No records found
    </div>
  </div>
  <div *ngIf="tinDataSource && tinDataSource.data.length">
    <mat-paginator #tinPaginator
      [length]="tinTotalRecords"
      [pageSize]="currentTinPageSize"
      [pageIndex]="currentTinPageIndex"
      [pageSizeOptions]="[5, 10, 20]"
      aria-label="Select page"
      (page)="onTinPageChange($event)">
    </mat-paginator>
   
  </div>
     
    </div>

    <div class="mobile-cards mobile-only" *ngIf="tinDataSource.data.length > 0">
      <div class="location-card" *ngFor="let item of tinDataSource.data">
          <div class="card-row">
              <span class="card-label">Existing</span>
              <span class="card-value">{{ item.IsTinFromDW }}</span>
          </div>
          <div class="card-row">
              <span class="card-label">TIN</span>
              <span class="card-value">{{ item.taxId }}</span>
          </div>
          <div class="card-row">
              <span class="card-label">Tax entity name</span>
              <span class="card-value">{{ item.taxEntityName }}</span>
          </div>
          <div class="card-row">
              <span class="card-label">Address</span>
              <span class="card-value">{{ item.taxEntityAddress1 }}</span>
          </div>
          <div class="card-row">
              <span class="card-label">Payee address</span>
              <span class="card-value">{{ item.payeeAddress1 }}</span>
          </div>
          <div class="card-row">
              <span class="card-label">Action</span>
              <span class="card-value">
              <button class="btn-action" [ngClass]="getTinActionStatusClass(item)"
                   (click)="onTinTableClick({row: item, data: item.taxId, otherParams: 'uploadW9'})">
                   {{ hasTinW9Document(item) ? 'View W9' : 'Upload W9' }}
               </button>
               <button class="btn-action delete-x-btn" *ngIf="hasTinW9Document(item)"
                   (click)="onTinTableClick({row: item, data: item.taxId, otherParams: 'deleteW9'})">
                   ×
               </button>
              </span>
          </div>
      </div>
  </div>

  
  </div>
</div>
 
    
    <app-wizard-navigation (back)="onBack()" (next)="onNext()" (cancel)="onCancel()" [showNextOnly]="true" [disableNext]="false">
    </app-wizard-navigation>
</div>